module.exports = __webpack_public_path__ + "img/logo.9f8f3990.svg";